import { useTranslation } from "react-i18next";
import { useState } from "react";

import apiClient from "../../lib/common/apiClient";

import ConfirmDialog from "../dialogTypes/ConfirmDialog";
import ActionButtonLayout from './../layout/ActionButtonLayout';


function TkTotalAmountCalculationAgreeButton(props) {

    const { t } = useTranslation();

    const { id, schema, grid, refresh, makeItemName, onSuccess, onFailure, onPartialFailure, detailList, agreementState, ...others } = props;

    const [open, setOpen] = useState(false);
    const [confirmMsg, setConfirmMsg] = useState();
    // const [confirmData, setConfirmData] = useState();
    const onOpen = () => {

        // setConfirmMsg(t("dialog.msg.confirm.delete", { type: t(`tableName.${schema.name}`), instance: deleteItemStr }));
        setConfirmMsg(t(`dialog.msg.confirm.${agreementState}`));
        // setConfirmData(detailList);

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onOk = () => {

        let url = `/api/TkTotalAmountCalculation/${agreementState}`;

        apiClient.put(url, { detailList })
            .then((result) => {
                if (onSuccess) {
                    onSuccess(result.data);
                }
            })
            .catch((reason) => {
                console.error(reason);
                onFailure(t(`error.${agreementState}Failure`, { reason: reason.response ? reason.response.data : reason }))

            });

    }

    return (

        <>
            <ActionButtonLayout onClick={onOpen} {...others}>{t(`buttonName.${agreementState}`)}</ActionButtonLayout>
            <ConfirmDialog
                id={id + `-${agreementState}-confirm-dialog`}
                title={schema ? t(`dialog.title.${schema.name}.${agreementState}`) : ""}
                msg={confirmMsg}
                // data={confirmData}
                open={open}
                onClose={onClose}
                onOk={onOk}
                onCancel={onClose}
            />
        </>

    );

}

export default TkTotalAmountCalculationAgreeButton;

